import styled from '@emotion/styled'
import { Button, ButtonBase, Dialog, LinearProgress } from '@mui/material'
import { colors, fontSize, size } from '@styles/theme'

const SelectionButton = styled(Button)`
  background-color: #333333 !important;
  padding: ${size(2)} ${size(7)};
  border: 1px solid rgba(255, 255, 255, 0.1);
`

const replaceStyles = (isLoading) => ({
  color: isLoading ? 'grey' : colors.success(500),
  borderRadius: '12px 12px 0 0',
  fontSize: fontSize('sm'),
})

const removeStyles = (isLoading) => ({
  color: isLoading ? 'grey' : colors.error(500),
  borderRadius: '0 0 12px 12px',
  fontSize: fontSize('sm'),
  borderTop: 'none',
})

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  padding: 0 2rem 4rem 2rem;
  background-color: transparent;
  z-index: 2;
`

const LoaderText = styled.h3`
  display: flex;
  align-items: center;
  text-align: center;
`

const slotProps = {
  backdrop: {
    style: {
      backgroundColor: 'rgba(0,0,0,0.8)'
    }
  },
  paper: {
    style: {
      backgroundColor: 'transparent',
      overflowX: 'hidden'
    }
  }
}

const ReplaceRemoveDialog = ({ isOpen, setClosed, afterSelect, isLoading, isLoadingDelayed, loadingText }) => {
  
  const renderOptions = () => (
    <>
      <SelectionButton
        disabled={isLoading}
        style={replaceStyles(isLoading)}
        onClick={() => afterSelect('replace')}>
        REPLACE
      </SelectionButton>
      <SelectionButton
        disabled={isLoading}
        style={removeStyles(isLoading)}
        onClick={() => afterSelect('remove')}>
        REMOVE
      </SelectionButton>
    </>
  )

  const renderLoader = () => (
    <LoaderContainer>
      <LoaderText>{loadingText}</LoaderText>
      <br />
      <LinearProgress style={{ width: `calc(100dvw - ${size(6)})` }} />
    </LoaderContainer>
  )

  return (
    <Dialog
      slotProps={slotProps}
      onClose={setClosed}
      open={isOpen}>
      {!isLoadingDelayed
        ? renderOptions()
        : renderLoader()
      }
    </Dialog>
  )
}

export default ReplaceRemoveDialog